import Chip from '@mui/material/Chip'
import { useIntl } from 'react-intl'
import { DerivedStatus } from '../../model/ISystemStatusMessage'
import { STATUS_CHIP_TOKENS } from '../../utils/severityTokens'

const STATUS_LABEL_ID: Record<DerivedStatus, string> = {
  Active: 'systemStatus.status.active',
  Pending: 'systemStatus.status.pending',
  Expired: 'systemStatus.status.expired'
}

const StatusChip = ({ status }: { status: DerivedStatus }) => {
  const intl = useIntl()
  const token = STATUS_CHIP_TOKENS[status]

  return (
    <Chip
      size="small"
      label={intl.formatMessage({ id: STATUS_LABEL_ID[status] })}
      sx={{
        height: 22,
        borderRadius: '11px',
        fontWeight: 500,
        fontSize: 11.5,
        backgroundColor: token.bg,
        color: token.text,
        border: token.border,
        '& .MuiChip-label': { px: '8px' }
      }}
    />
  )
}

export default StatusChip
